import ReactMarkdown from 'react-markdown';

/**
 * Safe markdown renderer for LLM responses. Uses react-markdown so user-controlled
 * content is rendered as React nodes — no dangerouslySetInnerHTML, no XSS surface.
 *
 * Tailwind classes are injected via `components` so the visual style matches the
 * previous regex-based formatter (bold, headings, lists, inline code).
 */
const components = {
  h1: ({ node, ...props }) => <h2 className="font-bold text-lg mt-3 mb-1" {...props} />,
  h2: ({ node, ...props }) => <h3 className="font-bold text-base mt-3 mb-1" {...props} />,
  h3: ({ node, ...props }) => <h4 className="font-bold text-sm mt-3 mb-1" {...props} />,
  h4: ({ node, ...props }) => <h4 className="font-bold text-sm mt-3 mb-1" {...props} />,
  strong: ({ node, ...props }) => <strong className="font-semibold" {...props} />,
  em: ({ node, ...props }) => <em className="italic" {...props} />,
  code: ({ node, inline, ...props }) =>
    inline ? (
      <code className="bg-slate-100 px-1 py-0.5 rounded text-xs font-mono" {...props} />
    ) : (
      <code className="block bg-slate-100 p-2 rounded text-xs font-mono whitespace-pre-wrap" {...props} />
    ),
  ul: ({ node, ...props }) => <ul className="ml-4 list-disc space-y-1 my-2" {...props} />,
  ol: ({ node, ...props }) => <ol className="ml-4 list-decimal space-y-1 my-2" {...props} />,
  li: ({ node, ...props }) => <li className="text-sm leading-relaxed" {...props} />,
  p: ({ node, ...props }) => <p className="mb-2 last:mb-0" {...props} />,
  a: ({ node, ...props }) => (
    <a className="text-orange-600 underline" target="_blank" rel="noopener noreferrer" {...props} />
  ),
};

export default function MarkdownMessage({ children, className = '' }) {
  return (
    <div className={`text-sm leading-relaxed ${className}`}>
      <ReactMarkdown components={components}>{children || ''}</ReactMarkdown>
    </div>
  );
}
